import { useAtom } from 'jotai';

import { EVENT_ID } from '@constants/atoms';

const useEventColorsAtom = () => useAtom(EVENT_ID);

export default useEventColorsAtom;
